import { BatchModelDto } from '@treasury/api/channel';

export const defaultBatchModelDto: BatchModelDto = {
    batchReference: '',
    events: [],
    locationName: '',
    totalAmount: 0,
    status: '',
    statusDescription: '',
    totalCount: 0,
};
